import { render } from "./Onboarding.vue?vue&type=template&id=08311c48&scoped=true"
import script from "./Onboarding.vue?vue&type=script&lang=js"
export * from "./Onboarding.vue?vue&type=script&lang=js"

import "./Onboarding.vue?vue&type=style&index=0&id=08311c48&lang=scss&scoped=true"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08311c48"]])

export default __exports__